<template>
  <BaseModal
    :is-open="modelValue"
    modal-name="How it works"
    class="max-w-2xl bg-linen p-0"
    no-margin-top
    @update:is-open="$emit('update:modelValue', $event)"
  >
    <template #closeBtn>
      <div class="absolute right-4 top-4 z-50 flex flex-1 items-center justify-end px-2 py-1">
        <button
          cy-data="modal-close-btn"
          class="flex items-center justify-center self-end rounded-full bg-linen p-2"
          @click="$emit('update:modelValue', false)"
        >
          <XIcon class="size-4 text-terracota-dark" />
        </button>
      </div>
    </template>
    <HowItWorksModalContent @close="$emit('update:modelValue', false)" />
  </BaseModal>
</template>

<script lang="ts" setup>
  import { XIcon } from '@heroicons/vue/solid';
  import BaseModal from '@/components/BaseModal.vue';
  import HowItWorksModalContent from '@/components/HowItWorksModalContent.vue';

  interface Props {
    modelValue?: boolean;
  }

  withDefaults(defineProps<Props>(), { modelValue: false });

  interface Emits {
    (e: 'update:modelValue', value: boolean): void;
  }

  defineEmits<Emits>();
</script>
